function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#E3E7F4",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#5B627C",
  fillRule: "nonzero",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.25 7.75A.759.759 0 0 0 8.5 7c-.2 0-.373.072-.518.217l-3.734 3.735c-.123.123-.248.275-.248.548s.105.405.242.543l3.74 3.74A.707.707 0 0 0 8.5 16c.446 0 .75-.381.75-.75 0-.194-.07-.37-.218-.518L5.8 11.5l3.232-3.232a.711.711 0 0 0 .218-.518zm6.502 3.202l-3.735-3.734A.707.707 0 0 0 11.5 7a.758.758 0 0 0-.75.75c0 .194.07.37.218.518L14.2 11.5l-3.232 3.232a.711.711 0 0 0-.218.518c0 .369.305.75.75.75.2 0 .373-.072.518-.217l3.74-3.74c.137-.138.242-.27.242-.543s-.125-.425-.248-.548z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#CFD4E5",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgScript = function SvgScript(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScript, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/script.05c1e4e1.svg";
export { ForwardRef as ReactComponent };